/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const DocketsListPropTypes = {
  /**
   * actions to use
   */
  actions: PropTypes.object,

  /**
   * History object
   */
  history: PropTypes.object,

  /**
   * Stored settings for docket list
   */
  listSettings: PropTypes.object,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The width of viewport
   */
  width: PropTypes.string,

  /**
   * Services
   */
  services: PropTypes.object,
};

export default DocketsListPropTypes;
